/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
import { useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { MdDeleteSweep } from "react-icons/md";
import moment from "moment";
import {
  DEFAULT_VEHICLE,
  EMPTY_LOCK,
  EMPTY_PICTURES,
  REGISTRATION_TYPES,
  STATUS_LIST,
  VEHICLE_TYPES,
} from "../constants";
import Loader from "../../../components/PageLoader";
import BreadCrumb from "../../../components/breadCrumb";
import { Paths } from "../../../routes/paths";
// import Information from "./Information";

import {
  useLookupCashCenters,
  useLookupCities,
  useLookupCustomers,
  useLookupOffices,
} from "../../../services/lookups-mutations";
import { useAddVehicles } from "../../../services/vehicles";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import FormInput from "../../../components/forms/form-Input";
import FormHookDatePicker from "../../../components/forms/form-hook-date-picker";
import NumericInput from "../../../components/forms/react-hook-numeric-input";

export default function AddVehicle() {
  const navigate = useNavigate();

  const { mutate: getCustomers, isPending: gettingCustomerList } =
    useLookupCustomers();

  const { mutate: getCities, data: citiesList } = useLookupCities();

  const {
    mutate: getCashCenter,
    data: cashCenterList,
    isPending: gettingCashCenterList,
  } = useLookupCashCenters();
  const {
    mutate: getOffices,
    data: officesList,
    reset: resetOffices,
  } = useLookupOffices();

  const {
    mutate: createRequest,
    isSuccess: isRequestCreated,
    isPending: creatingRequest,
  } = useAddVehicles();

  useEffect(() => {
    if (isRequestCreated) {
      navigate(Paths.vehiclesList);
    }
  }, [isRequestCreated]);

  useEffect(() => {
    getCashCenter();
    getCustomers();
    getCities("UAE");
  }, []);

  const {
    handleSubmit,
    control,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...DEFAULT_VEHICLE,
      ...EMPTY_LOCK,
      ...EMPTY_PICTURES,
    },
  });

  const generalFieldProps = { control, errors };
  const formValidationRules = {
    cashCenterId: { required: "Please Select Cash Center" },
    fleetNo: { required: "Please Enter Fleet No" },
    registrationNo: { required: "Please Enter Registration No" },
    make: { required: "Please Enter Make" },
    model: { required: "Please Enter Model" },
    manufacturingYear: {
      required: "Please Select Manufacturing Year",
      validate: (value) => {
        if (value > Number(moment().year())) {
          return "Please Enter Valid Year";
        }
        return true;
      },
    },
    registrationYear: {
      validate: (value) => {
        if (value > Number(moment().year())) return "Please Enter Valid Year";
        return true;
      },
    },
    vanType: { required: "Please Select Van Type" },
  };
  const {
    fields: installedLocksList,
    remove: installedLocksRemove,
    append: addLocks,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "installedLocks",
  });

  const onCashCenterChange = (e) => {
    const _value = e.target.value;
    if (!_value || _value.cashCenterId === "0") {
      resetOffices();
    } else {
      getOffices(_value.cashCenterId);
    }
  };
  const addLock = () => {
    const data = getValues();
    clearErrors(["lockType", "lockSerilNo", "vender"]);
    let isDataValid = true;
    if (!data.lockType) {
      setError("lockType", {
        type: "required",
        message: "Please Enter Lock Type",
      });
      isDataValid = false;
    }
    if (!data.vender) {
      setError("vender", {
        type: "required",
        message: "Please Enter Vender",
      });
      isDataValid = false;
    }
    if (!data.lockSerilNo) {
      setError("lockSerilNo", {
        type: "required",
        message: "Please Enter Lock Serial No",
      });
      isDataValid = false;
    }
    if (!isDataValid) return;
    const lock = {
      lockType: data.lockType,
      vender: data.vender,
      lockSerilNo: data.lockSerilNo,
    };
    setValue("lockType", "");
    setValue("vender", "");
    setValue("lockSerilNo", "");
    addLocks(lock);
  };
  const onSave = (data) => {
    const payload = {
      cashCenterId: data.cashCenterId?.cashCenterId || "",
      officeId: data.officeId?.officeId,
      fleetNo: data.fleetNo,
      registrationNo: data.registrationNo,
      make: data.make,
      model: data.model,
      manufacturingYear: data.manufacturingYear,
      vanType: data.vanType.id,
      engineNo: data.engineNo,
      chassisNo: data.chassisNo,
      color: data.color,
      city: data.city.name,
      purchaseDate: data.purchaseDate,
      registrationType: data.registrationType.id,
      registrationYear: data.registrationYear,
      registrationExpiry: data.registrationExpiry,
      insurer: data.insurer,
      insuranceExpiry: data.insuranceExpiry,
      armouredBy: data.armouredBy,
      armouringDate: data.armouringDate,
      lastFitnessDate: data.lastFitnessDate,
      fitnessDueDate: data.fitnessDueDate,
      fitnessInterval: data.fitnessInterval,
      fuelTag: data.fuelTag,
      cashLimit: data.cashLimit,
      status: data.status?.id || "",
      issuedTo: data.issuedTo,
      installedLocks: data.installedLocks.map((elm) => ({
        lockType: elm.lockType,
        vender: elm.vender,
        lockSerilNo: elm.lockSerilNo,
      })),
    };
    createRequest(payload);
  };

  return (
    <>
      {gettingCashCenterList || creatingRequest || gettingCustomerList ? (
        <Loader />
      ) : (
        <></>
      )}

      <div className="form-container">
        <BreadCrumb
          links={[
            { text: "Vehicles", link: Paths.vehiclesList },
            { text: "Add Vehicle", isCurrentPage: true },
          ]}
        />

        <Flex w="100%" mt="20px">
          <Card flexDirection="column" w="100%">
            <CardBody>
              <div className="add-location-form">
                <form onSubmit={handleSubmit(onSave)}>
                  <ReactHookFormDropdown
                    {...generalFieldProps}
                    isRequired
                    label="Cash Center"
                    name="cashCenterId"
                    id="cashCenterId"
                    text="name"
                    data={cashCenterList?.data || []}
                    placeholder="Select Cash Center"
                    rules={formValidationRules.cashCenterId}
                    onChange={onCashCenterChange}
                  />
                  <ReactHookFormDropdown
                    {...generalFieldProps}
                    label="Office"
                    name="officeId"
                    id="officeId"
                    text="officeName"
                    data={officesList?.data || []}
                    placeholder="Select Offices"
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    label="Fleet No"
                    name="fleetNo"
                    rules={formValidationRules.fleetNo}
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    label="Registration No"
                    name="registrationNo"
                    rules={formValidationRules.registrationNo}
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    label="Make"
                    name="make"
                    rules={formValidationRules.make}
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    label="Model"
                    name="model"
                    rules={formValidationRules.model}
                  />
                  <NumericInput
                    {...generalFieldProps}
                    isRequired
                    label="Manufacturing Year"
                    name="manufacturingYear"
                    inputProps={{ format: "#", className: "hide-spinners" }}
                    rules={formValidationRules.manufacturingYear}
                  />

                  <ReactHookFormDropdown
                    {...generalFieldProps}
                    isRequired
                    required
                    label="Van Type"
                    name="vanType"
                    id="id"
                    text="text"
                    data={VEHICLE_TYPES}
                    placeholder="Select Van Type"
                    rules={formValidationRules.vanType}
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Engine No"
                    name="engineNo"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Chassis No"
                    name="chassisNo"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Color"
                    name="color"
                  />
                  <ReactHookFormDropdown
                    {...generalFieldProps}
                    required
                    label="City"
                    name="city"
                    id="name"
                    text="name"
                    data={citiesList?.data || []}
                    placeholder="Select City"
                  />
                  <FormHookDatePicker
                    {...generalFieldProps}
                    datePickerProps={{
                      placeholder: "Select Purchase Date",
                    }}
                    label="Purchase Date"
                    name="purchaseDate"
                  />
                  <ReactHookFormDropdown
                    {...generalFieldProps}
                    required
                    label="Registration Type"
                    name="registrationType"
                    id="id"
                    text="text"
                    data={REGISTRATION_TYPES}
                    placeholder="Select Registration Type"
                  />

                  <NumericInput
                    {...generalFieldProps}
                    label="Registration Year"
                    name="registrationYear"
                    inputProps={{ format: "#", className: "hide-spinners" }}
                    rules={formValidationRules.registrationYear}
                  />
                  <FormHookDatePicker
                    {...generalFieldProps}
                    datePickerProps={{
                      placeholder: "Select Registration Expiry",
                    }}
                    label="Registration Expiry"
                    name="registrationExpiry"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Insurer"
                    name="insurer"
                  />
                  <FormHookDatePicker
                    {...generalFieldProps}
                    datePickerProps={{
                      placeholder: "Select Insurance Expiry",
                    }}
                    label="Insurance Expiry"
                    name="insuranceExpiry"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Armoured By"
                    name="armouredBy"
                  />
                  <FormHookDatePicker
                    {...generalFieldProps}
                    datePickerProps={{
                      placeholder: "Select Armouring Date",
                    }}
                    label="Armouring Date"
                    name="armouringDate"
                  />
                  <FormHookDatePicker
                    {...generalFieldProps}
                    datePickerProps={{
                      placeholder: "Select Last Fitness Date",
                    }}
                    label="Last Fitness Date"
                    name="lastFitnessDate"
                  />
                  <FormHookDatePicker
                    {...generalFieldProps}
                    datePickerProps={{
                      placeholder: "Select Fitness Due Date",
                    }}
                    label="Fitness Due Date"
                    name="fitnessDueDate"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Fitness Interval"
                    name="fitnessInterval"
                  />

                  <FormInput
                    {...generalFieldProps}
                    label="Cash Limit"
                    name="cashLimit"
                  />
                  <ReactHookFormDropdown
                    {...generalFieldProps}
                    required
                    label="Status"
                    name="status"
                    id="id"
                    text="text"
                    data={STATUS_LIST}
                    placeholder="Select Status"
                  />
                  <FormInput
                    {...generalFieldProps}
                    label="Issued To"
                    name="issuedTo"
                  />
                  <FormControl>
                    <FormLabel style={{ visibility: "hidden" }}>
                      Fuel Tag
                    </FormLabel>
                    <Controller
                      control={generalFieldProps.control}
                      name="fuelTag"
                      render={({ field }) => {
                        return (
                          <Checkbox
                            isChecked={field.value}
                            onChange={field.onChange}
                          >
                            <FormLabel style={{ margin: 0 }}>
                              Fuel Tag
                            </FormLabel>
                          </Checkbox>
                        );
                      }}
                    />
                  </FormControl>
                  <Heading
                    style={{
                      width: "100%",
                      fontSize: "14px",
                      borderTop: `1px solid var(--primary-light)`,
                      padding: "10px 0px",
                      margin: 0,
                    }}
                  >
                    Installed Locks
                  </Heading>
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    label="Lock Type"
                    name="lockType"
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    label="Vender"
                    name="vender"
                  />
                  <FormInput
                    {...generalFieldProps}
                    isRequired
                    label="Lock Serial No"
                    name="lockSerilNo"
                  />
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "16px",
                    }}
                  >
                    <Button onClick={addLock} type="button">
                      Add Lock
                    </Button>
                  </div>
                  <Grid data={installedLocksList}>
                    <GridColumn title="Lock Type" field="lockType" />
                    <GridColumn title="Vender" field="vender" />
                    <GridColumn title="Lock Serial No" field="lockSerilNo" />
                    <GridColumn
                      title="Delete"
                      headerClassName="text-center"
                      width={80}
                      cell={({ dataIndex }) => (
                        <td key={dataIndex}>
                          <Flex
                            title="Delete Lock"
                            cursor="pointer"
                            onClick={() => {
                              installedLocksRemove(dataIndex);
                            }}
                          >
                            <MdDeleteSweep fontSize="18px" color="red" />
                          </Flex>
                        </td>
                      )}
                    />
                  </Grid>
                  {/* <Heading
                    style={{
                      width: "100%",
                      fontSize: "14px",
                      borderTop: `1px solid var(--primary-light)`,
                      padding: "10px 0px",
                      margin: 0,
                    }}
                  >
                    Pictures
                  </Heading>
                  <FormControl>
                    <FormLabel>Upload Picture</FormLabel>
                    <input
                      type={"file"}
                      accept="image/*"
                      onChange={(e) => {
                        console.log("E", e.target.value);
                      }}
                    />
                  </FormControl> */}
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "16px",
                      borderTop: `1px solid var(--primary-light)`,
                      padding: "10px 0px",
                    }}
                  >
                    <Button type="submit">Add Vehicle</Button>
                  </div>
                </form>
              </div>
            </CardBody>
          </Card>
        </Flex>
      </div>
    </>
  );
}
